import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class GuestParams extends Vue {
  children = "";
  pensioners = false;
  birthday = "";
  registrated = "";
  cruise_code = "";
  gender = "";
  doc_type = "";
  citizenship = "";

  show_age = true;
  show_room = true;
  show_document = true;
  show_phone_number = true;
  show_birthday = true;
  show_order_number = false;
  show_ad = false;
  show_email = false;
  show_gender = false;
  show_table = true;
  show_comment = false;
  show_zit = true;
  show_check = true;

  show_plan_guests = true;
  show_plan_children = true;
  show_plan_pensioners = true;
  show_plan_cell = false;

  mounted(): void {
    this.rememberSaved();
  }

  rememberSaved(): void {
    const show_table = localStorage.getItem("show_table");
    if (show_table) this.show_table = parseInt(show_table) ? true : false;

    const s_plan_guests = localStorage.getItem("guest_show_plan_guests");
    if (s_plan_guests)
      this.show_plan_guests = parseInt(s_plan_guests) ? true : false;

    const s_plan_children = localStorage.getItem("guest_show_plan_children");
    if (s_plan_children)
      this.show_plan_children = parseInt(s_plan_children) ? true : false;

    const s_plan_pensioners = localStorage.getItem(
      "guest_show_plan_pensioners"
    );
    if (s_plan_pensioners)
      this.show_plan_pensioners = parseInt(s_plan_pensioners) ? true : false;

    const s_plan_cell = localStorage.getItem("guest_show_plan_cell");
    if (s_plan_cell) this.show_plan_cell = parseInt(s_plan_cell) ? true : false;

    const s_birthday = localStorage.getItem("guest_show_birthday");
    if (s_birthday) this.show_birthday = parseInt(s_birthday) ? true : false;

    const show_gender = localStorage.getItem("guest_show_gender");
    if (show_gender) this.show_gender = parseInt(show_gender) ? true : false;

    const show_comment = localStorage.getItem("guest_show_comment");
    if (show_comment) this.show_comment = parseInt(show_comment) ? true : false;

    const show_doc = localStorage.getItem("guest_show_document");
    if (show_doc) this.show_document = parseInt(show_doc) ? true : false;

    const show_pn = localStorage.getItem("guest_show_phone_number");
    if (show_pn) this.show_phone_number = parseInt(show_pn) ? true : false;

    const show_email = localStorage.getItem("guest_show_email");
    if (show_email) this.show_email = parseInt(show_email) ? true : false;

    const show_room = localStorage.getItem("guest_show_room");
    if (show_room) this.show_room = parseInt(show_room) ? true : false;

    const show_on = localStorage.getItem("guest_show_order_number");
    if (show_on) this.show_order_number = parseInt(show_on) ? true : false;

    const show_ad = localStorage.getItem("guest_show_ad");
    if (show_ad) this.show_ad = parseInt(show_ad) ? true : false;

    const show_age = localStorage.getItem("guest_show_age");
    if (show_age) this.show_age = parseInt(show_age) ? true : false;
  }

  @Watch("show_zit")
  remembershow_zit(): void {
    localStorage.setItem("show_zit", this.show_zit ? "1" : "0");
  }

  @Watch("show_table")
  remembershow_table(): void {
    localStorage.setItem("show_table", this.show_table ? "1" : "0");
  }

  @Watch("show_birthday")
  rememberShowBirthday(): void {
    localStorage.setItem("guest_show_birthday", this.show_birthday ? "1" : "0");
  }

  @Watch("check")
  rememberShowCheck(): void {
    localStorage.setItem("guest_show_check", this.show_check ? "1" : "0");
  }

  @Watch("show_gender")
  rememberShowGender(): void {
    localStorage.setItem("guest_show_gender", this.show_gender ? "1" : "0");
  }

  @Watch("show_comment")
  rememberShowComment(): void {
    localStorage.setItem("guest_show_comment", this.show_comment ? "1" : "0");
  }

  @Watch("show_document")
  rememberShowDocument(): void {
    localStorage.setItem("guest_show_document", this.show_document ? "1" : "0");
  }

  @Watch("show_phone_number")
  rememberShowPhoneNumber(): void {
    localStorage.setItem(
      "guest_show_phone_number",
      this.show_phone_number ? "1" : "0"
    );
  }

  @Watch("show_email")
  rememberShowEmail(): void {
    localStorage.setItem("guest_show_email", this.show_email ? "1" : "0");
  }

  @Watch("show_order_number")
  rememberShowOrderNumber(): void {
    localStorage.setItem(
      "guest_show_order_number",
      this.show_order_number ? "1" : "0"
    );
  }

  @Watch("show_ad")
  rememberShowAD(): void {
    localStorage.setItem("guest_show_ad", this.show_ad ? "1" : "0");
  }

  @Watch("show_room")
  rememberShowRoom(): void {
    localStorage.setItem("guest_show_room", this.show_room ? "1" : "0");
  }

  @Watch("show_age")
  rememberShowAge(): void {
    localStorage.setItem("guest_show_age", this.show_age ? "1" : "0");
  }

  @Watch("show_plan_guests")
  rememberShowPlanGuests(): void {
    localStorage.setItem(
      "guest_show_plan_guests",
      this.show_plan_guests ? "1" : "0"
    );
  }

  @Watch("show_plan_children")
  rememberShowPlanChildren(): void {
    localStorage.setItem(
      "guest_show_plan_children",
      this.show_plan_children ? "1" : "0"
    );
  }

  @Watch("show_plan_pensioners")
  rememberShowPlanPensioners(): void {
    localStorage.setItem(
      "guest_show_plan_pensioners",
      this.show_plan_pensioners ? "1" : "0"
    );
  }

  @Watch("show_plan_cell")
  rememberShowPlanCell(): void {
    localStorage.setItem(
      "guest_show_plan_cell",
      this.show_plan_cell ? "1" : "0"
    );
  }
}
